module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Medium.cac930af.woff";